import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CurrentUser } from 'app/services/currentUser.service';
import { UserAccount } from 'app/services/userAccount.service';

@Component({
  selector: 'session-header',
  templateUrl: './sessionHeader.component.html',
  styleUrls: ['./sessionHeader.component.scss'],
})
export class SessionHeaderComponent {
  login = true;
  url;
  firstName;
  isDone;
  constructor(public router: Router,
     public currentUser: CurrentUser,
     public userAccount: UserAccount,
     public activatedRoute: ActivatedRoute) {
    this.firstName = userAccount.data.first_name;
    if (this.currentUser.get() ? this.currentUser.get().username : false) {
      this.login = false;
      this.url = ['/stories'];
    }
  }

  public currentRoute() {
    return this.router.url.includes('login');
  }

  public inContribLogIn() {
    let invitationContrib;
    if (this.login) {
      if (this.router.url.includes('contrib') && this.currentUser.get() ? this.currentUser.get().guest : false) {
        this.url = ['account/login'];
        invitationContrib = this.router.url;
      } else {
        this.url = ['/stories'];
      }
    }
    this.router.navigate(this.url, {queryParams: {contrib: invitationContrib}});
  }

  public inPasswordReset() {
    if (this.router.url.includes('reset')) {
      return true;
    } else {
      return false;
    }
  }

  public islogged() {
    if (this.currentUser.get() ? this.currentUser.get().guest : true) {
      return false;
    } else {
      return true;
    }
  }
}
